import React, { memo } from 'react';
import PropTypes from 'prop-types';
import messages from 'aurora-translations';
import { injectIntl } from 'react-intl';
import isObject from 'lodash/isObject';
import { TilesSelect, FiltersTextField, FiltersSelect, FiltersDatePicker } from 'aurora-components';
import { FIELD_TYPES } from './constants';
import useFiltersActions from './helpers';

const ADGMFilterComponent = ({
  intl,
  name,
  type,
  data,
  handleChange,
  isAccordion,
  showDropdownAsPrefix,
  onPrefixChange,
  dropDownValue,
}) => {
  const { value, label, placeholder, options, ...otherProps } = data;
  const { transformDropDownData } = useFiltersActions();
  const getLokaliseData = lokaliseKey => {
    return isObject(messages[lokaliseKey]) ? intl.formatMessage({ ...messages[lokaliseKey] }) : lokaliseKey;
  };

  switch (type) {
    case FIELD_TYPES?.FIELD:
      return (
        <FiltersTextField
          id={name}
          name={name}
          label={getLokaliseData(label)}
          value={value}
          placeholder={
            placeholder ? getLokaliseData(placeholder) : `${getLokaliseData('enter')} ${getLokaliseData(label)}`
          }
          onChange={handleChange}
          isAccordion={isAccordion}
          {...otherProps}
          showDropdownAsPrefix={showDropdownAsPrefix}
          dropDownOptions={options}
          onPrefixChange={onPrefixChange}
          dropDownValue={dropDownValue}
        />
      );
    case FIELD_TYPES?.RADIO:
      return (
        <TilesSelect
          name={name}
          label={getLokaliseData(label)}
          value={value}
          options={transformDropDownData(name, options)}
          onChange={handleChange}
          isAccordion={isAccordion}
          {...otherProps}
        />
      );
    case FIELD_TYPES?.SELECT:
      return (
        <FiltersSelect
          id={name}
          name={name}
          type='select'
          label={getLokaliseData(label)}
          value={value}
          placeholder={
            placeholder ? getLokaliseData(placeholder) : `${getLokaliseData('select')} ${getLokaliseData(label)}`
          }
          options={options}
          onChange={handleChange}
          isAccordion={isAccordion}
          {...otherProps}
        />
      );
    case FIELD_TYPES?.DATE:
      return (
        <FiltersDatePicker
          datePickerProps={{
            date: value,
            onChange: handleChange,
            ...otherProps,
          }}
          textFieldProps={{
            id: name,
            name,
            value,
            label: getLokaliseData(label),
            placeholder: placeholder
              ? getLokaliseData(placeholder)
              : `${getLokaliseData('select')} ${getLokaliseData(label)}`,
            autoComplete: 'off',
            onChange: handleChange,
            ...otherProps,
          }}
          isAccordion={isAccordion}
        />
      );
    default:
      return null;
  }
};

ADGMFilterComponent.propTypes = {
  intl: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  isAccordion: PropTypes.bool,
  showDropdownAsPrefix: PropTypes.bool,
  dropDownOptions: PropTypes.object,
  onPrefixChange: PropTypes.func,
  dropDownValue: PropTypes.any,
};

ADGMFilterComponent.defaultProps = {
  dropDownValue: '',
  isAccordion: false,
  showDropdownAsPrefix: false,
  dropDownOptions: [],
  onPrefixChange: () => {},
};

export default injectIntl(memo(ADGMFilterComponent));
